<template>
    <div class="modal fade" id="modalOrderCertified" tabindex="-1" role="dialog" aria-labelledby="modalOrderCertified" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="confirmationModalLabel">{{$t('string.msg.modal.orders.label.title')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <div class="card" v-if="order && order.systemUser">
                                    <div class="card-header">
                                        <div class="form-row">
                                            <div class="col-md-6">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.modal.orders.parts.label.truckdriver')}}:
                                                </label>
                                                <p>{{` ${camelize(order.systemUser.firstName)} ${camelize(order.systemUser.lastName)}`}}</p>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.dashboard.orders.table.distance.title')}}:
                                                </label>
                                                <p> {{(parseInt(order.distance/1000))}} KM</p>
                                            </div>
                                        </div>

                                        <div class="form-row" v-if="order.statusOrder.toUpperCase() == 'PAID'"> 
                                            <div class="col-md-6"> 
                                                <label class="col-form-label">
                                                    {{$t('string.msg.modal.orders.parts.label.truckdriver.phone')}}:
                                                </label>
                                                <p>{{`${camelize(order.systemUser.primaryPhone)}`}}</p>
                                            </div>
                                        </div> 

                                        <div class="form-row">
                                            <div class="col-md-6">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.dashboard.orders.table.certified.title')}}:
                                                </label>
                                                <p>{{` ${camelize(order.certified.name)}`}}</p>
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="form-group col-md-12">
                                                <label  class="col-form-label">
                                                    {{$t('string.msg.dashboard.orders.table.description.title')}}:
                                                </label>
                                                <span><input type="text" v-model="order.description" class="form-control" :placeholder="$t(camelize(order.description))"></span>
                                            </div>
                                        </div>

                                        
                                        <div class="form-row">
                                            
                                            <div class="col-md-12" v-if="order.isTruckDecontaminated">
                                                <label  class="col-form-label">
                                                    {{$t('string.msg.truck.descontamined.admin.label')}}&nbsp;
                                                </label>
                                                <span v-if="order.isTruckDecontaminated == true">{{` ${($t('string.msg.yes'))}`}}</span>
                                                <span v-else-if="order.isTruckDecontaminated == false">{{` ${($t('string.msg.no'))}`}}</span>
                                            </div>

                                            
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-md-12">
                                                <label  class="col-form-label">
                                                    <stroang>{{$t('string.msg.order.payment.method.label')}}:</stroang>
                                                </label> 
                                                <div class="col-md-12">
                                                    <input type="radio" id="MONEY" :value="true" v-model="order.paymentMethod">  &nbsp;
                                                    <label class="col-form-label" for="MONEY">{{$t('string.msg.company.label.payment.money')}}</label> &nbsp; &nbsp;
                                                    <input type="radio" id="CREDIT_CARD" :value="false" v-model="order.paymentMethod">  &nbsp;
                                                    <label class="col-form-label" for="CREDIT_CARD">{{$t('string.msg.company.label.payment.credit.card')}}</label> &nbsp; &nbsp;
                                                    <input type="radio" id="DEBIT_CARD" :value="false" v-model="order.paymentMethod">  &nbsp;
                                                    <label class="col-form-label" for="DEBIT_CARD">{{$t('string.msg.company.label.payment.debit.card')}}</label>
                                                </div>
                                            </div>    
                                        </div>
                                        <div class="form-row">
                                            <div class="col-md-6">
                                                <label class="col-form-label">
                                                    <code class="highlighter-rouge">*</code>
                                                    <stroang>{{$t('string.msg.order.delivery.company.label')}}</stroang>
                                                </label>
                                            </div>
                                            <div class="col-md-7">
                                                <input type="radio" id="yesDelivery" :value="true" v-model="data.companyIsDelivery"> &nbsp; 
                                                <label class="col-form-label" for="yesDelivery">{{$t('string.msg.for.delivery')}}</label> &nbsp; &nbsp;
                                                <input type="radio" id="noDelivery" :value="false" v-model="data.companyIsDelivery"> &nbsp; 
                                                <label class="col-form-label" for="noDelivery">{{$t('string.msg.not.for.delivery')}}</label>
                                            </div>
                                        </div>
                                        <div class="form-row" v-show="data.companyIsInfosSufficient == false">
                                            <div class="col-md-12">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.order.company.msg.label')+':'}} &nbsp;
                                                </label>
                                                <input type="text" id="information" v-model="data.companyAddionalInformations" maxlength="100" size="42" />
                                            </div>
                                        </div><br/>
                                        <div class="form-row">
                                            <div class="form-group col-md-6">
                                                <label  class="col-form-label">
                                                    <code class="highlighter-rouge">*</code>
                                                    {{$t('string.msg.modal.orders.price')}}:
                                                </label>
                                                <input v-money="money" id="salary" v-model="data.total" type="text" class="form-control" :placeholder="$t('string.msg.product.parts.placeholder.price')" />
                                            </div>    
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div class="col-md-6">
                                <div class="card">

                                    <div class="card-header" v-if="order.truck!=null">
                                            <div v-if="order.truck" class="form-row">
                                                
                                                <div class="col-md-12" v-if="order.truck.vehicleType">
                                                    <label class="col-form-label">
                                                        {{$t('string.msg.modal.orders.truck.infos') + ':'}}&nbsp;<strong>  {{  toUpperCase($t(order.truck.vehicleType))}} </strong> 
                                                    </label>
                                                </div>
                                                
                                                <div v-if="order.truck.manufacturer.name" class="col-md-12">
                                                    <label class="col-form-label">
                                                        {{$t('string.msg.register.truck.label.manufacturer')}}:
                                                        {{order.truck.manufacturer.name}}
                                                    </label>
                                                </div>
                                                <div v-if="order.truck.model && order.truck.model.name" class="col-md-12">
                                                    <label class="col-form-label">
                                                        {{$t('string.msg.register.truck.label.model')}}:
                                                        {{order.truck.model.name}}
                                                    </label>
                                                </div>
                                                <div v-if="order.truck.year" class="col-md-12">
                                                    <label class="col-form-label">
                                                        {{$t('string.msg.register.truck.label.year')}}:
                                                        {{order.truck.year}}
                                                    </label>
                                                </div>
                                                <div v-if="order.truck.pbt" class="col-md-12">
                                                    <label class="col-form-label">
                                                        {{$t('string.msg.register.truck.label.pbt')}}:
                                                        {{order.truck.pbt}}
                                                    </label>
                                                </div>
                                            </div> 
                                    </div>  

                                    <div v-else class="card-header" >
                                        <div class="form-row">
                                            <div class="col-md-12">
                                                <p>
                                                    {{ $t('string.msg.nothing.found.truck') }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>    
                                    </div>     
                                </div>
                            </div>       
                        </form>
                        <div v-if="errors.length" class="alert alert-danger">
                            <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                            <ul>
                                <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                            </ul>
                        </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="$emit('confirmation-return', 0)">{{$t('string.msg.term.btn.cancel')}}</button>
                    <button type="button" class="btn btn-primary" v-on:click="checkForm()">{{$t('string.msg.modal.orders.btn.send')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Controller from './CrtModalOrderCertified';

    export default {
        props: ["order","trucks"],
        watch:{
            'order'(){
                this.order = this.order;
                this.data.companyAddionalInformations = this.order.companyAddionalInformations;
                this.data.companyIsDelivery = this.order.companyIsDelivery;
                this.data.companyIsInfosSufficient = this.order.companyIsInfosSufficient;
                this.data.companyIsPartAvailable = this.order.companyIsPartAvailable;
                this.data.companyIsPartOriginal = this.order.companyIsPartOriginal;
                this.data.companyPartBrand = this.order.companyPartBrand;
                if(this.order.total)
                {
                    this.data.total = this.order.total.toFixed(2);
                }
            },
            'trucks'(){
                this.trucks = this.trucks;
                this.trucks.manufacturer = this.trucks.manufacturer;
            }
        },
        data() {
            return {
                errors: [],
                titleToast: null,
                messageToast: null,
                messageIdToast: null,
                items: [],
               money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                data: {
                    total: 0.0,
                    companyIsInfosSufficient: null,
                    companyPartBrand: null,
                    companyAddionalInformations: null,
                    companyIsPartAvailable: null,
                    companyIsPartOriginal: null,
                    companyIsDelivery: null    
                }
            }
        },
        methods: Controller.methods,
        created() {
        },
        mounted(){
            // let company = this.$session.get('user').companyUser.company;
            Controller.init(this);
        }
    }
</script>

